export const TEST_SUBGROUP_OPTIONS = [
  "Амортизаторы",
  "Вентиляторы системы охлаждения двигателя",
  "Втулки амортизаторов",
  "Втулки рулевой рейки",
  "Втулки стабилизатора",
  "Главные тормозные цилиндры",
  "Главный цилиндр сцепления",
  "Датчики ABS",
  "Датчики положения кузова",
  "Катушки зажигания",
  "Кольца уплотнительные",
  "Крепежные изделия",
  "Крестовины карданные",
  "Крестовины рулевые",
  "Монтажный комплект",
  "Моторы отопителя салона",
  "Муфты карданного вала",
  "Наконечники рулевых тяг",
  "Направляющие втулки тормозного суппорта",
  "Опоры амортизатора",
  "Опоры шаровые",
  "Отбойники амортизаторов",
  "Патрубки",
  "Подушка рамы",
  "Подушки глушителя",
  "Подушки двигателя",
  "Подушки дифференциала",
  "Подшипники кондиционера",
  "Подшипники опоры амортизатора",
  "Подшипники подвесные карданного вала",
  "Подшипники роликовые",
  "Подшипники ступичные",
  "Подшипники шариковые",
  "Полуоси",
  "Поршни тормозного суппорта",
  "Приводы",
  "Проставки под пружины",
  "Прочее",
  "Пружины",
  "Пыльники амортизаторов",
  "Пыльники втулки направляющей",
  "Пыльники рулевой рейки",
  "Пыльники шаровых и наконечников",
  "Пыльники ШРУС",
  "Рабочие тормозные цилиндры",
  "Рабочие цилиндры сцепления",
  "Реактивные тяги",
  "Ремкомплекты тормозного суппорта",
  "Ремни ГРМ",
  "Ремни приводные",
  "Ролики",
  "Рулевые сошки",
  "Рычаги",
  "Сайлентблоки",
  "Сальники",
  "Свечи накаливания",
  "Система сцепления",
  "Ступицы",
  "Термостаты",
  "Тормозные колодки",
  "Тормозные суппорты",
  "Трипоиды",
  "Тросы",
  "Тяги рулевые",
  "Тяги стабилизатора",
  "Фильтры воздушные",
  "Фильтры салонные",
  "Шкивы коленвала",
  "ШРУСы внутренние",
  "ШРУСы наружные",
  "Элементы кузова",
] as const;
